import React from 'react'
import { Text, View } from 'react-native'
import { PlayerOutModal } from '../../../components/game/PlayerOutModal'

/**
 * Team games: the player-out notice when a player's exit knocks out their
 * whole team ("Team C has been eliminated"). In a live game it shows once, as
 * the pushed state grows `eliminated`, so a static fixture can't reach it;
 * this page renders it directly for the visual checkpoint. It never closes.
 */
export default function TeamEliminatedPreview() {
  return (
    <View className="flex-1 bg-canvas p-4" testID="team-eliminated-preview">
      <Text className="font-stencil text-ink text-sm uppercase">2v2v2 · Team C is out</Text>
      <PlayerOutModal
        reason="eliminated"
        playerName="Hannibal"
        playerSlot={6}
        bySlot={1}
        bySlotName="Visual Tester"
        teamOut="C"
        onClose={() => {}}
      />
    </View>
  )
}
